// src/pages/AboutUs.js
import React from 'react';
import { Container } from 'react-bootstrap';
import Aboutus from '../components/Aboutus';
const AboutUs = () => {
  return (
   <Aboutus/>
  );
};

export default AboutUs;
